export const XXS_WIDTH = 321;
export const XS_WIDTH = 575;
export const S_WIDTH = 767;
export const M_WIDTH = 991;
export const L_WIDTH = 1199;
export const XL_WIDTH = 100000;

export const VIEW_MODE_SBS = 'sideBySide';
export const VIEW_MODE_LIST = 'list';

export const SBS_VIEW_MODE_1_SESSION = 1;
export const SBS_VIEW_MODE_2_SESSIONS = 2;
export const SBS_VIEW_MODE_3_SESSIONS = 3;

export const SESSIONS_TAB_ALL = 'all';
export const SESSIONS_TAB_FAVOURITES = 'favourites';
export const SESSIONS_TAB_REGISTRATIONS = 'registrations';

export const ARRAY_NUMERATION_OFFSET = 1;

export const MODAL_OPEN_DELAY = 15000;

export const AGENDA_CONTAINER_ADDITIONAL_SIZE = 210;
export const SESSION_CONTAINER_ADDITIONAL_SIZE = 165;
export const WEBLOGIN_V2_OFFSET_TOP_DEFAULT = 460;
export const VIRTUAL_VENUE_BANNER_SIZE = 105;

export const REGISTER_AND_LOGIN_MODAL_AGENDA_PAGE = 'bz-register-and-login-modal-agenda';
export const REGISTER_AND_LOGIN_MODAL_SESSION_PAGE = 'bz-register-and-login-modal-session';

export const loginClickOrigin = {
    agenda: {
        login: 'Agenda > Login Button',
        interestStar: 'Agenda > Mark as interested Button',
        interestTab: 'Agenda > My Interests Tab',
        registerTab: 'Agenda > My Registered Sessions Tab',
        liveBanner: 'Agenda > Live Now Banner > Join Now Button',
        join: (buttonType) => `Agenda > ${buttonType} Button`,
    },
    session: {
        interestStar: 'Session > Mark as interested Button',
        rateHeart: 'Session > Rate Session',
        restriction: 'Session > Banner with Login Restriction',
        onDemandPlayBtn: 'Session > On Demand Play Button',
        join: (buttonType) => `Session > ${buttonType} Button`,
    },
    sessionPreview: {
        interestStar: 'Session Preview Drawer > Mark as interested Button',
        rateHeart: 'Session Preview Drawer > Rate Session',
        join: (buttonType) => `Session Preview Drawer > ${buttonType} Button`,
    },
    speaker: {
        likeBtn: 'Speaker > Like Speaker Button'
    }
};

export const loginTypes = {
    EMAIL_AND_TICKET_ID: 'EMAIL_AND_TICKET_ID',
    EMAIL: 'EMAIL',
    SSO: 'SSO',
};

export const loginSpinnerOrigin = {
    AGENDA_LOGIN: 'AGENDA_LOGIN',
    REGISTER_AND_LOGIN_MODAL: 'REGISTER_AND_LOGIN_MODAL',
    ANIMATED_RESTRICTION: 'ANIMATED_RESTRICTION',
    PRELIMINARY_ACCESS_ERROR: 'PRELIMINARY_ACCESS_ERROR',
    VIRTUAL_VENUE_BANNER: 'VIRTUAL_VENUE_BANNER',
};

export const RECORDING = 'RECORDING';

export const COOKIE_UNREGISTERED_USER_EMAIL = 'bz-unregistered-user-email';
